import { readStoredJson, writeStoredJson } from '@claritio/frontend/lib/storage'

// ENG-116: MRU of recently opened client workspaces for the switcher's "Recent"
// group. ENG-68: entries carry the name, so Recent renders before the client
// list has loaded — and still renders if that fetch fails.
const KEY = 'kx-recent-orgs'
const MAX = 5

export interface RecentOrg {
  id: number
  name: string
}

function isRecentOrg(value: unknown): value is RecentOrg {
  if (typeof value !== 'object' || value === null) return false
  const entry = value as Partial<RecentOrg>
  return Number.isInteger(entry.id) && typeof entry.name === 'string' && entry.name.length > 0
}

export function recentOrgs(): RecentOrg[] {
  const parsed = readStoredJson<unknown>(KEY, [])
  if (!Array.isArray(parsed)) return []
  // Pre-ENG-68 entries were bare ids: nothing to migrate a name from, and a
  // nameless entry has nothing to render, so they're dropped.
  return parsed.filter(isRecentOrg).slice(0, MAX)
}

export function pushRecentOrg(org: RecentOrg) {
  if (!isRecentOrg(org)) return
  // Re-push refreshes the name, so a renamed client stops showing the old one.
  writeStoredJson(KEY, [org, ...recentOrgs().filter((entry) => entry.id !== org.id)].slice(0, MAX))
}

// After sign-in an operator resumes the last client's Clara; with no recent client, the portfolio.
export function landingPath(): string {
  const last = recentOrgs()[0]
  return last ? `/chat?org_id=${last.id}` : '/home'
}
